import sliceCreator from '../../index.js';
import {DELETE_RAW_MATERIALS_BY_MACHINE} from '../../../constants/index.js';
const _deleterawMaterialMachineMappingAction = sliceCreator('DELETE_RAW_MATERIALS_BY_MACHINE', DELETE_RAW_MATERIALS_BY_MACHINE, 'delete');

const { asyncAction: deleteRawMaterialMachineMappingAction, reducer, clearData: clearDeleteRawMaterialMachineMappingAction } = _deleterawMaterialMachineMappingAction;

export default reducer;

export {
    deleteRawMaterialMachineMappingAction,
    clearDeleteRawMaterialMachineMappingAction
}